<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="4" md="4" xl="3">
        <BaseSelect v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')"
          :options="audioStationSelect.options"
          :data="audioStationSelect.data"
          ref="audioStationSelect"
        ></BaseSelect>
      </CCol>
      <CCol>
        <div class="form-group">
          <label v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')" style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Xuất báo cáo'"
              class="btn-action-primary"
              @click="exportSubmit()">
              <i class="fa fa-download"></i>&nbsp;&nbsp;Xuất báo cáo
            </CButton>
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="refreshSubmit()">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="12">
        <CCard v-if="statistic && statistic != undefined">
          <CCardHeader color="light">
            <i class="fa fa-file"></i>
            <strong> Số lượng thiết bị phát thanh </strong>
            <!--                    <small>kết nối </small>-->
            <strong>({{ statistic.total }})</strong>
          </CCardHeader>
          <CCardBody class="row text-center">
            <div class="col" style="color: #1bbf1b!important">
              <div class="text-value-lg">
                {{ statistic.statusActive || 0 }}
              </div>
              <div class="text-uppercase text-muted small">
                Đang hoạt động
              </div>
            </div>
            <div class="c-vr"></div>
            <div class="col" style="color: red!important">
              <div class="text-value-lg">
                {{ statistic.statusInactive || 0 }}
              </div>
              <div class="text-uppercase text-muted small">
                Không hoạt động
              </div>
            </div>
            <div class="c-vr"></div>
            <div class="col" style="color: #1bbf1b!important">
              <div class="text-value-lg">
                {{ statistic.connectActive || 0 }}
              </div>
              <div class="text-uppercase text-muted small">
                Đang kết nối
              </div>
            </div>
            <div class="c-vr"></div>
            <div class="col" style="color: red!important">
              <div class="text-value-lg">
                {{ statistic.connectInactive || 0 }}
              </div>
              <div class="text-uppercase text-muted small">
                Mất kết nối
              </div>
            </div>
          </CCardBody>
        </CCard>

        <CCard class="content-fade-in mt-3p5">
          <CCardBody>
            <BaseTable
              :options="mainTable.options"
              :slots="mainTable.slots"
              :dataSource="mainTable.dataSource"
              ref="mainTable"
            >
              <template #index="{index}">
                <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
              </template>
              <template #activeStatus="{item}">
                <td>
                  <span class="badge badge-success" v-if="item.activeStatus == 1">Hoạt động</span>
                  <span class="badge badge-danger" v-if="item.activeStatus == 0">Không hoạt động</span>
                </td>
              </template>
              <template #connectStatus="{item}">
                <td>
                  <span class="badge badge-success" v-if="item.connectStatus == 1">Kết nối</span>
                  <span class="badge badge-danger" v-if="item.connectStatus == 0">Mất kết nối</span>
                </td>
              </template>
            </BaseTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <BaseLoading :loading="loading.value"></BaseLoading>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2";
import BaseLoading from "../base/BaseFormLoading";
import {LOCATION_CODE_NAME} from "@/constant";

export default {
  name: "AudioFileList",
  components: {
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    BaseLoading
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    return {
      loading: {value: false},
      statistic: '',
      audioStationSelect: {
        options: {
          filter: true,
          label: "Đài truyền thanh",
          'keyField': 'value',
          'valueField': 'text',
          selectAllText: "Tất cả đài truyền thanh",
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_PROVINCE')) ? false : true
        },
        data: {
          name: "locationCode",
          source: {
            url: '/audio-station/list-audio-station-code-name',
            isJsonContentType: false,
            response: function (dataResponse) {
              return dataResponse.data;
            }
          },
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      mainTable: {
        options: {
          fields: [
            // {key: "checkbox", label: "#"},
            {key: "index", label: "STT"},
            {key: "deviceCode", label: "Mã thiết bị"},
            {key: "volumn", label: "Âm lượng"},
            {key: "activeStatus", label: "Trạng thái hoạt động"},
            {key: "connectStatus", label: "Trạng thái kết nối"},
            {key: "locationName", label: "Địa bàn"},
            // {key: "action", label: "Thao tác"}
          ],
          slots: ["index", "activeStatus", "connectStatus"],
          pageSize: 15
        },
        dataSource: {
          url: "/report/audio-device",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            that.statistic = dataResponse.data.statisticDevice;
            return dataResponse.data.pageDevice;
          }
        }
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    refreshSubmit() {
      this.loadDataMainTable(true);
    },
    exportSubmit() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/exports/audio-devices",
        dataSubmit: function () {
          return that.$helper.setupDataSubmit(that.$data);
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
          } else {
            that.$helper.fetchAndDownloadByURI(response.data.data.path, response.data.data.name);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    }
  },
  created: function () {
  },
  mounted() {
  },
  watch: {},
  computed: {}
};
</script>

